import React from "react";
import {
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
// import FacebookProfilesDashboardContext from "../../../../context/facebook_profiles/dashboard/DashboardContext";

// Components

const useStyles = makeStyles((theme) => ({
  root: {
    height: 100,
  },
  cell: {
    width: 300,
  },
}));

const BusinessInfo_01 = ({ bm_verification, ad_list }) => {
  const classes = useStyles();

  // const {} = useContext(FacebookProfilesDashboardContext);

  return (
    <TableContainer className={classes.root}>
      <Table size="small" stickyHeader>
        <TableBody>
          <TableRow>
            <TableCell variant="head" align="left">
              <strong> Business Verification Status </strong>
            </TableCell>
            <TableCell variant="body" align="center">
              {bm_verification.toUpperCase()}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell variant="head" align="left">
              <strong> Ad Account Creation Limit </strong>
            </TableCell>
            <TableCell variant="body" align="center">             
              {ad_list.length}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default BusinessInfo_01;
